import { z } from 'zod';

// pending holds spots for a checkout in flight; completed is a stay that ran. §13
export const RESERVATION_STATUSES = [
  'pending',
  'active',
  'cancelled',
  'expired',
  'completed',
] as const;

export const reservationStatusSchema = z.enum(RESERVATION_STATUSES);

export type ReservationStatus = z.infer<typeof reservationStatusSchema>;

// Only an active reservation holds a spot; the exclusion constraint filters on it.
export const HOLDING_RESERVATION_STATUS: ReservationStatus = 'active';

// Both hold their spots, so both sides of the double-booking guarantee. §13
export const HOLDING_RESERVATION_STATUSES: readonly ReservationStatus[] = ['active', 'pending'];

// A pending stay is nobody's booking yet: staff surfaces never show one. §12
export function holdsSpot(status: ReservationStatus): boolean {
  return HOLDING_RESERVATION_STATUSES.includes(status);
}

export const RESERVATION_SOURCES = ['staff', 'online'] as const;

export const reservationSourceSchema = z.enum(RESERVATION_SOURCES);

export type ReservationSource = z.infer<typeof reservationSourceSchema>;

export const PAYMENT_MODES = ['full', 'hold_fee', 'none'] as const;

export const paymentModeSchema = z.enum(PAYMENT_MODES);

export type PaymentMode = z.infer<typeof paymentModeSchema>;

export const PAYMENT_STATUSES = ['pending', 'paid', 'failed', 'refunded'] as const;

export const paymentStatusSchema = z.enum(PAYMENT_STATUSES);

export type PaymentStatus = z.infer<typeof paymentStatusSchema>;

// refund rows link back to the booking by code; see requirements §13.
export const PAYMENT_PURPOSES = ['booking', 'extension', 'refund'] as const;

export const paymentPurposeSchema = z.enum(PAYMENT_PURPOSES);

export type PaymentPurpose = z.infer<typeof paymentPurposeSchema>;

// Owner picks one step; guests extend a hold in whole multiples of it. See TODOS.md.
export const EXTENSION_STEP_MINUTES = [30, 60] as const;

export const extensionStepMinutesSchema = z.union([z.literal(30), z.literal(60)]);

export type ExtensionStepMinutes = z.infer<typeof extensionStepMinutesSchema>;
